import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, distinct, mergeMap, last, map, switchMap } from 'rxjs/operators';
import { AdminConsentRequestPolicy } from '@microsoft/microsoft-graph-types-beta';
import { retry } from 'projects/angular-clarity/src/app/pipes/retry.pipe';
import { TenantAjaxService } from 'projects/angular-clarity/src/app/services/ajax/tenant-ajax.service';
import * as actions from './actions';

@Injectable()
export class AdminConsentRequestPolicyEffects {
    loadAdminConsentRequestPolicy$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadAdminConsentRequestPolicy),
            distinct((action) => action._tenant),
            mergeMap(({ _tenant }) =>
                this.ajax
                    .get<AdminConsentRequestPolicy>(_tenant, '/api/microsoft/graph/policies/adminConsentRequestPolicy')
                    .pipe(
                        map((policy: AdminConsentRequestPolicy) =>
                            actions.loadAdminConsentRequestPolicySuccess({
                                _tenant,
                                policy,
                            }),
                        ),
                        catchError((error) =>
                            of(
                                actions.loadAdminConsentRequestPolicyFailure({
                                    _tenant,
                                    error,
                                }),
                            ),
                        ),
                    ),
            ),
        ),
    );

    updateAdminConsentRequestPolicy$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateAdminConsentRequestPolicy),
            mergeMap(({ _tenant, data }) =>
                this.put(_tenant, data).pipe(
                    map((data) =>
                        actions.updateAdminConsentRequestPolicySuccess({
                            _tenant,
                            data,
                        }),
                    ),
                    catchError((error) =>
                        of(
                            actions.updateAdminConsentRequestPolicyFailure({
                                _tenant,
                                error,
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    put(tenantId: string, data: AdminConsentRequestPolicy): Observable<AdminConsentRequestPolicy> {
        return this.ajax
            .put(tenantId, '/api/microsoft/graph/policies/adminConsentRequestPolicy', data)
            .pipe(
                switchMap(() =>
                    this.ajax.get<AdminConsentRequestPolicy>(
                        tenantId,
                        '/api/microsoft/graph/policies/adminConsentRequestPolicy',
                    ),
                ),
            );
    }

    constructor(
        private actions$: Actions,
        private ajax: TenantAjaxService,
    ) {}
}
